var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25.5,
    fill: "white",
    stroke: "#07CF84"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8087 20.5381C24.7173 20.5759 24.6392 20.64 24.5843 20.7222C24.5293 20.8044 24.5 20.9011 24.5 21L24.5 31C24.5 31.0989 24.5293 31.1956 24.5843 31.2778C24.6392 31.36 24.7173 31.4241 24.8087 31.4619C24.9 31.4998 25.0006 31.5097 25.0976 31.4904C25.1945 31.4711 25.2836 31.4235 25.3536 31.3535L30.3535 26.3535C30.4 26.3071 30.4368 26.252 30.4619 26.1913C30.4871 26.1307 30.5 26.0657 30.5 26C30.5 25.9343 30.4871 25.8693 30.4619 25.8087C30.4368 25.748 30.4 25.6929 30.3535 25.6465L25.3536 20.6465C25.2836 20.5765 25.1945 20.5289 25.0975 20.5096C25.0006 20.4903 24.9 20.5002 24.8087 20.5381Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideNext);
export default __webpack_public_path__ + "static/media/slide-next.46152fc7b5e8ce1b587b01753c170b73.svg";
export { ForwardRef as ReactComponent };